module.exports = __webpack_public_path__ + "static/img/4_4_1.5393f58c.jpg";